<script>
    import { createEventDispatcher } from 'svelte';

    export let caption;
    export let disabled;
    export let type;
    export let state = null;

    let selected = null;

    if (state !== null) {
        selected = +state;
    }

    const dispatch = createEventDispatcher();

    function select(value) {
        if (selected === value) {
            value = null;
        }

        selected = value;

        dispatch('selected', { type, value });
    }
</script>

<style>
    label.button {
        cursor: auto;
        height: 100%;
        font-size: 14px;
        user-select: auto;
    }

    .button {
        background: #101010;
        border-color: #0c0c0c;
        color: white;
    }

    .button:not(._selected)._up {
        color: #1f691f;
    }

    .button._selected._up {
        background: #1f691f;
    }

    .button:not(._selected)._down {
        color: #901818;
    }

    .button._selected._down {
        background: #901818;
    }

    .control:first-child {
        flex: 1;
    }

    .control:first-child > .button {
        width: 100%;
        justify-content: left;
    }
</style>

<div class="field has-addons">
    <p class="control">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="button">
            <span>{caption}</span>
        </label>
    </p>
    <p class="control">
        <button class="button _up" class:_selected={selected === 1} on:click={() => select(1)} disabled={disabled}>
            <span class="icon is-small">
                <i class="fas fa-thumbs-up"></i>
            </span>
        </button>
    </p>
    <p class="control">
        <button class="button _down" class:_selected={selected === 0} on:click={() => select(0)} disabled={disabled}>
            <span class="icon is-small">
                <i class="fas fa-thumbs-down"></i>
            </span>
        </button>
    </p>
</div>